import Vue from 'vue';
export const featureToggleMixin = Vue.extend({
    computed: {
        TOGGLES() {
            return this.$store.state.features;
        },
    },
    watch: {
        '$route.query.enable_feature': {
            immediate: true,
            handler(features, prev) {
                if (features) {
                    this.enableFeaturesTmp(features);
                }
                else if (prev && !features) {
                    this.resetFeatures();
                }
            },
        },
    },
    methods: {
        enableFeaturesTmp(features) {
            features.split(',').forEach((feat) => {
                this.$store.commit('features/enable', feat);
            });
        },
        resetFeatures() {
            this.$store.commit('features/reset');
        },
    },
});
